import { Component, OnInit, ViewChild } from '@angular/core';
import { _MSGTYPES, getCompOptionsByType, MSG_CONTENT_TYPE } from '../../shared/constant/msgType';
import { DialogService, IccMsgGeneratorComponent, MessageService } from 'icc-common-lib';
import { URLS } from '../../shared/constant/interface';
import { _HttpClient } from '@delon/theme';
import { MsgEditor } from '../../msg-interface/msg-editor';

@Component({
  selector: 'icc-tiktok-editor',
  templateUrl: './tiktok-editor.component.html',
  styles: [],
})
export class TiktokEditorComponent implements OnInit, MsgEditor {
  constructor(private dialogService: DialogService, private http: _HttpClient, private messageService: MessageService) {}
  @ViewChild('msgtplgenerator', { static: false }) tplGenerator: IccMsgGeneratorComponent;
  SCENE = 'icc-msg-editor';
  type = _MSGTYPES.MT.TIKTOK.type;
  // 是否自动匹配
  isAutoMath: boolean;
  // 自动匹配列表数据
  tplList: Array<any>;
  options = [
    {
      form: [
        {
          type: 'input',
          label: '标题',
          labelWidth: 60,
          require: true,
          placeholder: '请输入标题',
          maxlength: 50,
          disabled: false,
          config: {
            value: '',
          },
        },
        {
          type: 'nz-tabset',
          activeIndex: 0,
          tabList: [
            {
              title: '视频',
              form: [
                {
                  type: 'icc-video',
                  contentType: MSG_CONTENT_TYPE.VIDEO,
                  config: {
                    req: URLS.uploadImage.url,
                    url: '',
                    disabled: false,
                    success: result => {
                      this.setVideoUrl(result.filePath);
                    },
                    videoRemove: event => {
                      this.setVideoUrl();
                    },
                  },
                },
              ],
            },
            {
              title: '图片',
              form: [
                {
                  type: 'icc-image-upload',
                  contentType: MSG_CONTENT_TYPE.IMAGE,
                  config: {
                    editable: true,
                    imgList: [],
                    maxSize: 10,
                    maxCount: 1,
                    success: result => {
                      this.setImgUrl(result);
                    },
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ];
  // 【选择模板】模板id
  templateId: string;
  // 通道信息
  channelInfo: any;
  fileBaseUrl: string;
  ngOnInit() {
    this.fileBaseUrl = URLS.attachment.url + '?';
  }
  /* 数据校验 */
  validate(): boolean {
    if (this.isAutoMath || this.templateId) return true;
    const inputComp = this.messageService.getCompOptionsByType(this.options, 'input')[0];
    const tabset = this.messageService.getCompOptionsByType(this.options, 'nz-tabset')[0];
    const videoComp = tabset.tabList[0].form[0];
    const imageComp = tabset.tabList[1].form[0];
    if (!inputComp.config.value) {
      this.dialogService.notification.warning('提示', '抖音标题不能为空');
      return false;
    }
    if (!videoComp.config.url && tabset.activeIndex === 0) {
      this.dialogService.notification.warning('提示', '还没上传抖音视频');
      return false;
    }
    if ((!imageComp.config.imgList || !imageComp.config.imgList.length) && tabset.activeIndex === 1) {
      this.dialogService.notification.warning('提示', '还没上传抖音图片');
      return false;
    }
    return true;
  }
  /* 设置禁用状态 */
  setDisabled(disabled: boolean): void {
    const inputComp = this.messageService.getCompOptionsByType(this.options, 'input')[0];
    const tabset = this.messageService.getCompOptionsByType(this.options, 'nz-tabset')[0];
    inputComp.config.disabled = disabled;
    tabset.tabList[0].form[0].config.disabled = disabled;
    tabset.tabList[1].form[0].config.editable = !disabled;
  }
  /* 数据重置 */
  resetData() {
    const inputComp = this.messageService.getCompOptionsByType(this.options, 'input')[0];
    inputComp.config.value = '';
    const tabset = this.messageService.getCompOptionsByType(this.options, 'nz-tabset')[0];
    tabset.tabList[0].form[0].config.url = '';
    tabset.tabList[1].form[0].config.imgList = [];
    this.templateId = '';
    this.cancelAutoMathTpl();
  }
  /* 选择模板数据设置 */
  setSelectedTplData(tplData: any): void {
    if (tplData && tplData.content) {
      this.templateId = tplData.templateId;
      const inputComp = this.messageService.getCompOptionsByType(this.options, 'input')[0];
      const tabset = this.messageService.getCompOptionsByType(this.options, 'nz-tabset')[0];
      const videoComp = tabset.tabList[0].form[0];
      const imageComp = tabset.tabList[1].form[0];
      const parseContent = JSON.parse(tplData.content);
      inputComp.config.value = parseContent[0].title;
      switch (parseContent[0].contentType) {
        case MSG_CONTENT_TYPE.IMAGE:
          // 图片
          imageComp.config.imgList = [
            {
              url: this.fileBaseUrl + parseContent[0].mediaList[0].url,
            },
          ];
          tabset.activeIndex = 1;
          break;
        case MSG_CONTENT_TYPE.VIDEO:
          // 视频
          videoComp.config.url = this.fileBaseUrl + parseContent[0].mediaList[0].url;
          tabset.activeIndex = 0;
          break;
        default:
          break;
      }
    }
  }

  /* 设置自动匹配模板 */
  setAutoMathTpl(tplList: Array<any>): void {
    // 无自动匹配模板
    this.cancelAutoMathTpl();
  }

  cancelAutoMathTpl(): void {
    this.isAutoMath = false;
    this.tplList = [];
  }
  /* 获取数据 */
  getMessageData() {
    const message: any = {
      msgType: this.type,
      tiktokChannelId: this.channelInfo ? this.channelInfo.id : '',
    };
    const inputComp = this.messageService.getCompOptionsByType(this.options, 'input')[0];
    const tabset = this.messageService.getCompOptionsByType(this.options, 'nz-tabset')[0];
    const currentComp = tabset.tabList[tabset.activeIndex].form[0];
    message.contentType = currentComp.contentType;
    switch (currentComp.contentType) {
      case MSG_CONTENT_TYPE.VIDEO:
        message.items = [
          {
            title: inputComp.config.value,
            mediaList: [{ url: currentComp.config.url }],
          },
        ];
        break;
      case MSG_CONTENT_TYPE.IMAGE:
        message.items = [
          {
            title: inputComp.config.value,
            mediaList: currentComp.config.imgList,
          },
        ];
        break;
      default:
        break;
    }
    if (this.templateId) {
      message.templateId = this.templateId;
      message.items = [];
    }
    return message;
  }
  getMobilePreviewData() {
    throw new Error('Method not implemented.');
  }
  /* 通过业务类型id获取通道信息 */
  setChannelInfoByBizId(bizTypeId: string) {
    this.http.get(URLS.channelInfo.url + '/' + bizTypeId + '/' + this.type).subscribe(res => {
      if (res.status === 0 && res.data) {
        this.channelInfo = res.data[0];
      } else {
        this.dialogService.notification.error('错误', res.errorMsg);
      }
    });
  }
  /* 设置视频路径 */
  setVideoUrl(url?: string) {
    const tabset = this.messageService.getCompOptionsByType(this.options, 'nz-tabset')[0];
    const videoComp = tabset.tabList[0].form[0];
    videoComp.config.url = URLS.attachment.url + '?module=5&path=' + url;
  }
  /* 设置图片路径 */
  setImgUrl(result: any) {
    const tabset = this.messageService.getCompOptionsByType(this.options, 'nz-tabset')[0];
    const imgComp = tabset.tabList[1].form[0];
    imgComp.config.imgList = [
      {
        name: result.fileName,
        url: URLS.attachment.url + '?module=5&path=' + result.filePath,
        size: result.fileSize,
      },
    ];
  }
}
